module.exports = __webpack_public_path__ + "img/chin.2a78496a.svg";